import { useEffect, useRef, useState } from 'react';
import { TradeOrder } from '../types';
import { buildOrderHistory, createOrder } from '../data/orders';

interface Options {
  weeks?: number;
  perWeek?: number;
  /** Average milliseconds between simulated incoming orders */
  interval?: number;
  live?: boolean;
}

export function useLiveOrders({ weeks = 8, perWeek = 5, interval = 6500, live = true }: Options = {}) {
  const [orders, setOrders] = useState<TradeOrder[]>(() => buildOrderHistory(weeks, perWeek));
  const [latestId, setLatestId] = useState<string | null>(null);
  const timer = useRef<number | null>(null);

  useEffect(() => {
    if (!live) return undefined;

    const schedule = () => {
      const jitter = interval * (0.6 + Math.random() * 0.9);
      timer.current = window.setTimeout(() => {
        const order = createOrder(new Date(), 'Confirmed');
        setOrders((prev) => [order, ...prev].slice(0, 160));
        setLatestId(order.id);
        schedule();
      }, jitter);
    };

    schedule();
    return () => {
      if (timer.current) window.clearTimeout(timer.current);
    };
  }, [interval, live]);

  return { orders, latestId };
}
